import { render, staticRenderFns } from "./station.vue?vue&type=template&id=52ed0085&"
import script from "./station.vue?vue&type=script&lang=js&"
export * from "./station.vue?vue&type=script&lang=js&"
import style0 from "./station.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports